import { render, staticRenderFns } from "./memberNoticeTable.vue?vue&type=template&id=fa1b30d2&scoped=true&"
import script from "./memberNoticeTable.vue?vue&type=script&lang=ts&"
export * from "./memberNoticeTable.vue?vue&type=script&lang=ts&"
import style0 from "./memberNoticeTable.vue?vue&type=style&index=0&id=fa1b30d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1b30d2",
  null
  
)

export default component.exports